/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.occupation.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.occupation = {};
proto.witbooking.backoffice.occupation.v1 = require('./occupation_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse>}
 */
const methodDescriptor_OccupationAPI_GetAllConfigurations = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.occupation.v1.OccupationAPI/GetAllConfigurations',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest,
  proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse>}
 */
const methodInfo_OccupationAPI_GetAllConfigurations = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient.prototype.getAllConfigurations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/GetAllConfigurations',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_GetAllConfigurations,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.occupation.v1.GetAllConfigurationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient.prototype.getAllConfigurations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/GetAllConfigurations',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_GetAllConfigurations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest,
 *   !proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse>}
 */
const methodDescriptor_OccupationAPI_GetAllOccupations = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.occupation.v1.OccupationAPI/GetAllOccupations',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest,
  proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest,
 *   !proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse>}
 */
const methodInfo_OccupationAPI_GetAllOccupations = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient.prototype.getAllOccupations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/GetAllOccupations',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_GetAllOccupations,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.occupation.v1.GetAllOccupationsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient.prototype.getAllOccupations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/GetAllOccupations',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_GetAllOccupations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.occupation.v1.GetOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.GetOccupationResponse>}
 */
const methodDescriptor_OccupationAPI_GetOccupation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.occupation.v1.OccupationAPI/GetOccupation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.occupation.v1.GetOccupationRequest,
  proto.witbooking.backoffice.occupation.v1.GetOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.occupation.v1.GetOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.GetOccupationResponse>}
 */
const methodInfo_OccupationAPI_GetOccupation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.occupation.v1.GetOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.GetOccupationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.occupation.v1.GetOccupationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.occupation.v1.GetOccupationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient.prototype.getOccupation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/GetOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_GetOccupation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.GetOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.occupation.v1.GetOccupationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient.prototype.getOccupation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/GetOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_GetOccupation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse>}
 */
const methodDescriptor_OccupationAPI_CreateOccupation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.occupation.v1.OccupationAPI/CreateOccupation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest,
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse>}
 */
const methodInfo_OccupationAPI_CreateOccupation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient.prototype.createOccupation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/CreateOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_CreateOccupation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient.prototype.createOccupation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/CreateOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_CreateOccupation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse>}
 */
const methodDescriptor_OccupationAPI_CreateAllOccupation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.occupation.v1.OccupationAPI/CreateAllOccupation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest,
  proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse>}
 */
const methodInfo_OccupationAPI_CreateAllOccupation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient.prototype.createAllOccupation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/CreateAllOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_CreateAllOccupation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.occupation.v1.CreateAllOccupationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient.prototype.createAllOccupation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/CreateAllOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_CreateAllOccupation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse>}
 */
const methodDescriptor_OccupationAPI_CreateOccupationCloneOnly = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.occupation.v1.OccupationAPI/CreateOccupationCloneOnly',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest,
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse>}
 */
const methodInfo_OccupationAPI_CreateOccupationCloneOnly = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient.prototype.createOccupationCloneOnly =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/CreateOccupationCloneOnly',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_CreateOccupationCloneOnly,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.CreateOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.occupation.v1.CreateOccupationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient.prototype.createOccupationCloneOnly =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/CreateOccupationCloneOnly',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_CreateOccupationCloneOnly);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse>}
 */
const methodDescriptor_OccupationAPI_UpdateOccupation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.occupation.v1.OccupationAPI/UpdateOccupation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest,
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse>}
 */
const methodInfo_OccupationAPI_UpdateOccupation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient.prototype.updateOccupation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/UpdateOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_UpdateOccupation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.occupation.v1.UpdateOccupationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient.prototype.updateOccupation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/UpdateOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_UpdateOccupation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse>}
 */
const methodDescriptor_OccupationAPI_DeleteOccupation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.occupation.v1.OccupationAPI/DeleteOccupation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest,
  proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest,
 *   !proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse>}
 */
const methodInfo_OccupationAPI_DeleteOccupation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient.prototype.deleteOccupation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/DeleteOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_DeleteOccupation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.DeleteOccupationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.occupation.v1.DeleteOccupationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient.prototype.deleteOccupation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/DeleteOccupation',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_DeleteOccupation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest,
 *   !proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse>}
 */
const methodDescriptor_OccupationAPI_UpdateOccupationTypes = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.occupation.v1.OccupationAPI/UpdateOccupationTypes',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest,
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest,
 *   !proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse>}
 */
const methodInfo_OccupationAPI_UpdateOccupationTypes = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse,
  /**
   * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIClient.prototype.updateOccupationTypes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/UpdateOccupationTypes',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_UpdateOccupationTypes,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.occupation.v1.UpdateOccupationTypesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.occupation.v1.OccupationAPIPromiseClient.prototype.updateOccupationTypes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.occupation.v1.OccupationAPI/UpdateOccupationTypes',
      request,
      metadata || {},
      methodDescriptor_OccupationAPI_UpdateOccupationTypes);
};


module.exports = proto.witbooking.backoffice.occupation.v1;

